/**
 * Selected global keys that exist on window that will by default be assumed to not pertain to the model of components.
 * If this behavior needs to be overridden, props can be prefixed with "this" or "window
 * @type {Set<string>}
 */
export const PICKED_GLOBAL_KEYS: Set<string> = new Set([
	"window",
	"document",
	"navigator",
	"NaN",
	"undefined",
	"self",
	"event",
	"requestAnimationFrame",
	"cancelAnimationFrame",
	"postMessage",
	"getComputedStyle",
	"webkitRequestAnimationFrame",
	"webkitCancelAnimationFrame",
	"webkitCancelRequestAnimationFrame",
	"requestIdleCallback",
	"cancelIdleCallback",
	"setTimeout",
	"clearTimeout",
	"setInterval",
	"clearInterval",
	"atob",
	"btoa",
	"isNaN",
	"isFinite",
	"escape",
	"unescape",
	"decodeURI",
	"decodeURIComponent",
	"encodeURI",
	"encodeURIComponent",
	"EvalError",
	"ReferenceError",
	"SyntaxError",
	"Proxy",
	"JSON",
	"Math",
	"console",
	"Int8Array",
	"Int16Array",
	"Int32Array",
	"Uint8Array",
	"Uint8ClampedArray",
	"Uint16Array",
	"Uint32Array",
	"Float32Array",
	"Float64Array",
	"BigUint64Array",
	"BigInt64Array",
	"DataView",
	"Date",
	"Boolean",
	"Number",
	"WeakMap",
	"WeakSet",
	"parseInt",
	"parseFloat",
	"Object",
	"Function",
	"Array",
	"RegExp",
	"RangeError",
	"TypeError",
	"ArrayBuffer",
	"String",
	"Symbol",
	"Error",
	"Map",
	"Set",
	"Promise",
	"eval",
	"Intl",
	"Reflect",
	"WebAssembly",
	"customElements",
	"visualViewport",
	"CustomElementRegistry",
	"fetch",
	"CSS",
	"XMLHttpRequest",
	"URL",
	"URLSearchParams",
	"location",
	"history",
	"performance",
	"sessionStorage",
	"localStorage",
	"applicationCache",
	"indexedDB",
	"speechSynthesis",
	"BigInt",
	"chrome",
	"webkitRequestFileSystem",
	"webkitResolveLocalFileSystemURL",
	"SIMD",
	"DOMRect",
	"DOMPoint",
	"DOMQuad",
	"Blob",
	"File",
	"Animation",
	"MessageChannel",
	"MutationObserver",
	"IntersectionObserver",
	"ResizeObserver"
]);